// extracted by mini-css-extract-plugin
export default {"wrapper":"Y2-z","play":"Z2-z"};